var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.wallet)?_c('div',{attrs:{"id":"balance"}},[_c('i18n-n',{attrs:{"value":_vm.wallet.availableBalance,"format":_vm.currencyFormatSettings}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }